(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["smara-colour-swatches"] && !Shopify.designMode) return;
  try {
    (() => {
    const prefetched = new Set();
    const warmColour = (event) => {
      const link = event.target.closest?.('[data-smara-colour-link]');
      if (!link || prefetched.size >= 2) return;
      const connection = navigator.connection;
      if (connection?.saveData || /(^|-)2g$/.test(connection?.effectiveType || '')) return;
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin || prefetched.has(url.href)) return;
      prefetched.add(url.href);
      const hint = document.createElement('link');
      hint.rel = 'prefetch';
      hint.href = url.href;
      document.head.append(hint);
    };
    document.addEventListener('pointerover', warmColour, { passive: true });
    document.addEventListener('focusin', warmColour);
  })();
  } catch(e) { console.error(e); }
})();

})();
